import { Component, Inject, OnInit, signal } from '@angular/core';
import { JobHistory } from '../../../model/jobHistory.model';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { EscapeDialogHelper } from '../../../helpers/escape-dialog.helper';
import { UserService } from '../../../services/user.service';
import { MessagingService } from '../../../components/messaging/messaging.service';
import { CurrentUserService } from '../../../services/currentUser.service';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatDivider } from '@angular/material/divider';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAutoFillDisabledDirective } from '../../../directives/browser-auto-fill-disabled.directive';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable
} from '@angular/material/table';
import { TimePipe } from '../../../pipes/time.pipe';
import { DateHistoryPipe } from '../../../pipes/date.history.pipe';
import { Highlight } from '../../../pipes/highlight.pipe';

@Component({
  selector: 'app-job-history',
  templateUrl: './job-history.component.html',
  styleUrls: ['./job-history.component.scss'],
  imports: [
    MatDialogTitle,
    MatIconButton,
    MatDialogClose,
    MatIcon,
    MatDivider,
    CdkScrollable,
    MatDialogContent,
    MatFormField,
    MatLabel,
    MatInput,
    ReactiveFormsModule,
    BrowserAutoFillDisabledDirective,
    FormsModule,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatDialogActions,
    MatButton,
    TimePipe,
    DateHistoryPipe,
    Highlight
  ]
})
export class JobHistoryComponent implements OnInit {
  jobHistory = signal<JobHistory[]>([]);
  jobHistoryColumns = ['timeStamp', 'action'];
  stringHighlight: string;
  timezone: string;

  constructor(
    public dialogRef: MatDialogRef<JobHistoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private escapeDialogRef: EscapeDialogHelper,
    private userService: UserService,
    private currentUserService: CurrentUserService,
    private message: MessagingService
  ) {}

  ngOnInit(): void {
    this.escapeDialogRef.escapeDialog(this.dialogRef);
    this.userService.getJobHistoryForJob(this.data.jobId).subscribe({
      next: (jobHistory) => this.jobHistory.set(jobHistory),
      error: () => this.message.error('Could not retrieve the job history')
    });
    this.timezone = this.currentUserService?.timeZone;
  }
}
